const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute
  * @returns an option selection corresponding to the current user.
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const infoSource = {
    type: 'clientInfoBehavior'
  };
  const _await$evaluateSource = await evaluateSource(infoSource, content, parentContentPath, transientContext, nativeFunctions),
    userID = _await$evaluateSource.userID,
    firstName = _await$evaluateSource.firstName,
    lastName = _await$evaluateSource.lastName;
  if (userID === undefined) {
    return undefined;
  }
  return {
    [userID]: {
      title: [firstName, lastName].join(' ')
    }
  };
};
module.exports = {
  evaluate
};